import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=1530e2d7&scoped=true&"
import script from "./AddCoupon.vue?vue&type=script&lang=js&"
export * from "./AddCoupon.vue?vue&type=script&lang=js&"
import style0 from "./AddCoupon.vue?vue&type=style&index=0&id=1530e2d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530e2d7",
  null
  
)

export default component.exports